<div *ngIf="cases">
  <mat-checkbox [checked]="allComplete"
                [indeterminate]="someComplete()"
                (change)="setAll($event.checked)">
    Select All
  </mat-checkbox>
</div>
<ul class="m-l-0 m-t-5 simple-scroll" style="max-height: 200px;">
  <li *ngFor="let case of cases">
    <mat-checkbox [(ngModel)]="case.checked"
                  (ngModelChange)="updateAllComplete()">
      {{case.caseId}}
    </mat-checkbox>
  </li>
</ul>

